import { assertActionHandler } from "./validate";
function defineAction(identifier, handler) {
  assertActionHandler(identifier, handler);
  return function() {
  };
}
var AppIntents = Object.freeze({
  defineAction
});
export {
  AppIntents
};
//# sourceMappingURL=unavailable.js.map
